export function distributionServiceId(shop) {
  return String(shop && shop.distribution_product_service_id || '')
}

export function hasApplicationPolicy(shop) {
  return !!shop && Array.isArray(shop.secondary_product_apps) && typeof shop.distribution_allowed === 'boolean' &&
    Object.prototype.hasOwnProperty.call(shop, 'distribution_product_service_id') &&
    (typeof shop.secondary_product_subscribed === 'boolean' || shop.secondary_product_subscribed === null)
}

export function usesPrimaryApplication(shop, defaultId) {
  const selected = distributionServiceId(shop)
  return !!shop && !!defaultId && (selected === defaultId || (!selected && shop.distribution_allowed === true &&
    shop.secondary_product_subscribed === false && Array.isArray(shop.secondary_product_apps) && !shop.secondary_product_apps.length))
}

export function distributionApplicationName(shop, apps, defaultId) {
  if (!hasApplicationPolicy(shop)) return '状态暂不可用'
  if (usesPrimaryApplication(shop, defaultId)) return '主商品应用'
  const selected = distributionServiceId(shop)
  if (!selected) return '未指定'
  const app = apps.find(item => item.service_id === selected)
  return app ? app.app_name : `应用 ${selected}（当前不可用）`
}

export function mainApplicationReady(shop, now) {
  return !!shop && Number(shop.status) === 1 && Number(shop.app_product_status) === 1 && Number(shop.app_expire_time) > now
}

export function secondaryApplicationState(shop, serviceId, now) {
  if (!shop || !Array.isArray(shop.secondary_product_apps)) return { key: 'unavailable', text: '状态暂不可用', tone: 'muted', ok: false, expiry: null }
  const record = shop.secondary_product_apps.find(item => String(item.service_id) === serviceId)
  if (!record) return { key: 'unauthorized', text: '未授权', tone: 'muted', ok: false, expiry: null }
  const expiry = Number(record.app_expire_time)
  if (!Number.isFinite(expiry) || expiry <= 0) return { key: 'unknown', text: '待确认', tone: 'muted', ok: false, expiry: null }
  if (expiry <= now) return { key: 'expired', text: '服务已到期', tone: 'warning', ok: false, expiry }
  if (Number(record.app_product_status) !== 1) return { key: 'abnormal', text: '授权异常', tone: 'warning', ok: false, expiry }
  return { key: 'ready', text: '授权正常', tone: 'success', ok: true, expiry }
}

export function secondaryApplicationSummary(shop, apps, defaultId) {
  if (!hasApplicationPolicy(shop)) return { text: '状态暂不可用', tone: 'muted', action: '查看应用' }
  if (shop.secondary_product_subscribed === null) return { text: '第二应用权益待确认', tone: 'muted', action: '查看应用' }
  if (shop.distribution_allowed === true) return {
    text: shop.sales_assessment_exempt === true ? '应用就绪 · 双应用免考核' : '应用就绪 · 使用主应用铺货',
    tone: 'success', action: shop.secondary_product_subscribed === false ? '开通第二应用' : '管理应用'
  }
  const selected = distributionServiceId(shop)
  if (shop.secondary_product_subscribed === true && (!selected || selected === defaultId)) return {
    text: '已订购，但尚未指定铺货第二应用', tone: 'warning', action: '选择铺货应用'
  }
  if (selected && selected !== defaultId && !apps.some(item => item.service_id === selected)) return { text: '当前铺货应用不可用', tone: 'warning', action: '管理应用' }
  return { text: '应用需处理', tone: 'warning', action: shop.secondary_product_subscribed === false ? '开通第二应用' : '管理应用' }
}
